var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-[#B9BABA] h-1 w-full rounded-full relative"},[_c('div',{staticClass:"h-1 absolute rounded-full transition-[width] justify-end flex items-center",class:{ 'bg-[#34617E]': !_setup.props.completedColor },style:({
			width: _setup.props.progresso + '%',
			backgroundColor: _setup.props.completedColor || undefined,
		})},[(_setup.props.progresso && !_vm.hideInnerLabel)?_c('span',{staticClass:"rounded-sm text-xs font-semibold text-white-neutral pr-2"},[_vm._v(_vm._s(_setup.props.progresso)+"%")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }